import React from 'react';
import PropTypes from 'prop-types';
import { t } from '@insight/toolkit-utils/lib/labels';

import Button from '../Button/Button';

const HeaderSearchSuggestion = ({
  onSelect,
  query,
  removeSuggestion,
  suggestion,
}) => {
  const { phrase, category } = suggestion;
  const normalizedPhase = phrase.toLowerCase();
  const normalizeQuery = query.toLowerCase();

  const hasMatch = normalizedPhase.indexOf(normalizeQuery) !== -1;

  const matchStartIndex = hasMatch
    ? normalizedPhase.indexOf(normalizeQuery)
    : 0;
  const matchEndIndex = hasMatch ? matchStartIndex + normalizeQuery.length : 0;

  const before = phrase.slice(0, matchStartIndex);
  const match = phrase.slice(matchStartIndex, matchEndIndex);
  const after = phrase.slice(matchEndIndex);

  const handleClick = (event) => {
    event.preventDefault();
    onSelect(suggestion);
  };

  return (
    <li className="c-header-search-suggestions__item o-grid">
      <Button
        color="subtle"
        fullWidth
        onClick={handleClick}
        className="c-header-search-suggestions__btn o-grid__item"
      >
        {before}
        <span className="c-header-search-suggestions__match">{match}</span>
        {after}
        {category && (
          <span className="c-header-search-suggestions__category">
            {' in '}
            {category}
          </span>
        )}
      </Button>
      {removeSuggestion && (
        <Button
          className="o-grid__item o-grid__item--shrink"
          color="link"
          icon="close"
          onClick={() => {
            removeSuggestion(suggestion);
          }}
          size="small"
          aria-label={t('Delete search suggestion')}
        />
      )}
    </li>
  );
};

export default HeaderSearchSuggestion;

HeaderSearchSuggestion.propTypes = {
  onSelect: PropTypes.func.isRequired,
  query: PropTypes.string.isRequired,
  removeSuggestion: PropTypes.func,
  suggestion: PropTypes.shape({}).isRequired,
};

HeaderSearchSuggestion.defaultProps = {
  removeSuggestion: null,
};
